export interface HotListOrderItem {
	id: string;
	hotListItemId: string;
	orderedProductId: string;
	quantity: number;
	hotDate: Date;
	reason: string;
	releasedOn: Date | null;
	releasedById: string | null;
	resolvedOn: Date | null;
	resolvedById: string | null;
	createdOn: Date;
	createdById: string;
	updatedOn: Date;
	updatedById: string;
}

export function isHotListOrderItemReleased(item: HotListOrderItem): boolean {
	return !!item.releasedOn;
}
